// extracted by mini-css-extract-plugin
export default {"SingleImage":"SingleImage-module__SingleImage--TXJT3","wide":"SingleImage-module__wide--vw61k"};